import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/datosfacturacion';

import Select from 'react-select';

import {api} from '../../actions/_request';
import FileUploader from './fileuploader';
import ModalTablas from '../catalogos/modal_tablas';


const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const Actualizar = [
    {label: 'Precio', value: 1},
    {label: 'Costo', value: 2},
   
];
const Metodos = [
    {label: 'UEPS', value: 1},
    {label: 'PEPS', value: 2},
   
];


class ParamtrosModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            impuesto: {
                id:0,
                f_precios:'999,999,999.99',
                actualizar:1,
                metodo_costeo:1, 
                decimales_cantidades:2,                         
            },
            action: 'save',
            activeTab: '1',
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            codigo_regimen:'',
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);               
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
        this.toggle_modal= this.toggle_modal.bind(this); 
        this.retorno= this.retorno.bind(this);
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);          
    }
    handleClose (event) {
        
         
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
        switch (name) {
            case "codigo_regimen":                 
                  campo = "regimen_id";
                  tabla="/sat/regimen_fiscal_codigo";
                  break;
            case "clave_banco":                 
                  campo = "banco_id";
                  tabla="/sat/banco_codigo";
                  break;        
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                     }
                     self.retorno(response.data,campo,vaciar,value);        
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }

     retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let campo_codigo="";
        let rfc_banco="";
        let nombre_banco="";
        console.log('renglon---->',objeto);
        let {impuesto} = this.state;
        let self =this;
        switch (campo) {
            case "regimen_id":
                  codigo=objeto.codigo;
                  campo_codigo="codigo_regimen"; 
                  impuesto[campo] = objeto.id;
                  break;
            case "banco_id":
                  codigo=objeto.clave;
                  campo_codigo="clave_banco"; 
                  impuesto[campo] = objeto.id;
                  rfc_banco=objeto.rfc;
                  nombre_banco=objeto.nombre;
                  break;       
        }  
       if(vacio==1){
        console.log('vaciar')
        codigo=valor;
        impuesto[campo] =0;
        rfc_banco="";
        nombre_banco="";
       }
        // console.log("state---->",impuesto);
       if(campo=="banco_id"){
        self.setState({
            impuesto : impuesto,           
            [campo_codigo]:codigo,
            modal:false, 
            rfc_banco:rfc_banco,
            nombre_banco:nombre_banco,    
        })

       }else{
        self.setState({
            impuesto : impuesto,           
            [campo_codigo]:codigo,
            modal:false,         
        })
       }
    
        


    }
   
    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            impuesto: {
                ...this.state.impuesto,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {
            let self = this;
            api().get(`datos_facturacion/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        impuesto: response.data.datos,
                        codigo_regimen:response.data.regimen,
                        clave_banco:response.data.banco.clave,
                        rfc_banco:response.data.banco.rfc,
                        nombre_banco:response.data.banco.nombre,
                        action: 'update'
                    });

                }

            });
        
       
    }

    handleInputChange(event) {
        let {impuesto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value=0;
            if(target.checked)
                value=1;
        }
        

        impuesto[name] = value;
     
        this.setState({
            impuesto : impuesto
        });
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {impuesto} = this.state;
        let action=this.state.action;
        
        let save=true;
        let dato="";
        let self = this;
        var xml = this.refs.xml_sin_firma_sello.getFileObject();
        var cambio_xml = this.refs.xml_sin_firma_sello.cambio(); 
        // console.log("xml---->",xml);
       
        if (typeof(xml) === "undefined" || cambio_xml==false) {
            
        }else{
            impuesto.xml_sin_firma_sello=xml.name;
        }
        
        // console.log("cambio_xml---->",cambio_xml);
        var cer = this.refs.certificado_digital.getFileObject();
        var cambio_cer = this.refs.certificado_digital.cambio();
         if (typeof(cer) === "undefined" || cambio_cer==false) {
            
        }else{
            impuesto.certificado_digital=cer.name;
        }
        // console.log("cer---->",cer);
        // console.log("cambio_cer---->",cambio_cer);
        var key = this.refs.llave_privada.getFileObject();
        var cambio_key = this.refs.llave_privada.cambio();  
        if (typeof(key) === "undefined" || cambio_key==false) {
             
        }else{
            impuesto.llave_privada=key.name;
        }
        // console.log("key---->",key);
        // console.log("cambio_key---->",cambio_key);
        // impuesto=this.objeto_mayusculas(impuesto);
        let data = new FormData();
           data.append('registro', JSON.stringify(impuesto));
           data.append('xml', xml);           
           data.append('cambio_xml', cambio_xml);
           data.append('cer', cer);           
           data.append('cambio_cer', cambio_cer);
           data.append('key', key);           
           data.append('cambio_key', cambio_key);     

        if(save){

            

               
                        this.props[action](data,1, (data) => {
                        swal({
                            title: ' Los Datos de Facturacion',
                            text: 'Los Datos de Facturacion Fueron Guardados correctamente!',
                            type: 'success',
                            // showCancelButton: true,
                            // confirmButtonColor: '#3085d6',
                            // cancelButtonColor: '#d33',
                            confirmButtonText: 'Continue!'
                        }).then((result) => {
                            if (result.value) {
                              
                               
                               
                                self.props.toggle();
                                
                            }
                        })
                    });

                
            

           


         

        }else{
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        

      

    }

    render()
    {

        let {impuesto}=this.state;
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>Datos de la Factura Electronica</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos de la Empresa
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                          Parametros
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => { this.toggle_tab('3'); }}
                        >
                          Archivos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '4' })}
                          onClick={() => { this.toggle_tab('4'); }}
                        >
                          Folios
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            <Row>
                                <Col sm="12">
                                    <div className="row mt-4 mb-4">
                                        <div className="col-md-6 div_titulo mr-2">
                                         <h1><span>Datos del Emisor</span></h1>
                                            <div className="row ">
                                       
                                                <div className="col-md-8">
                                                    <FormGroup>
                                                        <Label>Nombre *</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="nombre_emisor"
                                                        maxLength={199}
                                                        value={impuesto.nombre_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>RFC *</Label>
                                                            <Input
                                                            placeholder=""
                                                            type="text"
                                                            name="rfc_emisor"
                                                            maxLength={13}
                                                            value={impuesto.rfc_emisor}
                                                            onChange={ this.handleInputChange}
                                                            />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-12">
                                                    <FormGroup>
                                                        <Label>Calle *</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="calle_emisor"
                                                        maxLength={199}
                                                        value={impuesto.calle_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Municipio *</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="municipio_emisor"
                                                        maxLength={99}
                                                        value={impuesto.municipio_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Estado *</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="estado_emisor"
                                                        maxLength={99}
                                                        value={impuesto.estado_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Pais *</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="pais_emisor"
                                                        maxLength={99}
                                                        value={impuesto.pais_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>C.P</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="cp_emisor"
                                                        maxLength={10}
                                                        value={impuesto.cp_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Numero Ext.</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="numero_ext_emisor"
                                                        maxLength={20}
                                                        value={impuesto.numero_ext_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Numero Int.</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="numero_int_emisor"
                                                        maxLength={20}
                                                        value={impuesto.numero_int_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Colornia</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="colonia_emisor"
                                                        maxLength={99}
                                                        value={impuesto.colonia_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Localidad</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="localidad_emisor"
                                                        maxLength={99}
                                                        value={impuesto.localidad_emisor}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Regimen Fiscal </label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="codigo_regimen"
                                                    value={this.state.codigo_regimen}
                                                     onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button_sm"
                                                  
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(7,"Regimen Fiscal","regimen_id") } }>...</Button>
                                                </div>
                                            </div>


                                            </div>
                                        </div>
                                        <div className="col-md-5 div_titulo">
                                         <h1><span>Lugar de Expedicion</span></h1>
                                            <div className="row ">
                                       
                                                
                                                 <div className="col-md-12">
                                                    <FormGroup>
                                                        <Label>Calle </Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="calle_expedicion"
                                                        maxLength={199}
                                                        value={impuesto.calle_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Municipio </Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="municipio_expedicion"
                                                        maxLength={99}
                                                        value={impuesto.municipio_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Estado </Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="estado_expedicion"
                                                        maxLength={99}
                                                        value={impuesto.estado_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Pais </Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="pais_expedicion"
                                                        maxLength={99}
                                                        value={impuesto.pais_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>C.P</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="cp_expedicion"
                                                        maxLength={10}
                                                        value={impuesto.cp_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Numero Ext.</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="numero_ext_expedicion"
                                                        maxLength={20}
                                                        value={impuesto.numero_ext_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Numero Int.</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="numero_int_expedicion"
                                                        maxLength={20}
                                                        value={impuesto.numero_int_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Colornia</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="colonia_expedicion"
                                                        maxLength={99}
                                                        value={impuesto.colonia_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Localidad</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="localidad_expedicion"
                                                        maxLength={99}
                                                        value={impuesto.localidad_expedicion}
                                                        onChange={ this.handleInputChange}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>                                   
                                    </div>                    
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <div className="row mt-4 mb-4">
                                        <div className="col-md-12 div_titulo mr-2">
                                         <h1><span>Datos Bancarios</span></h1>
                                         <div className="row" >
                                          <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Clave Banco </label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="clave_banco"
                                                    value={this.state.clave_banco}
                                                     onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button_sm"
                                                  
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(0,"Bancos","banco_id") } }>...</Button>
                                                </div>
                                            </div>
                                         </div>
                                            <div className="row ">
                                       
                                                <div className="col-md-6">
                                                    <FormGroup>
                                                        <Label>Nombre *</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="nombre_emisor"
                                                        
                                                        value={this.state.nombre_banco}
                                                        onChange={ this.handleInputChange}
                                                        readOnly
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-3">
                                                    <FormGroup>
                                                        <Label>RFC *</Label>
                                                            <Input
                                                            placeholder=""
                                                            type="text"
                                                            name="rfc_emisor"
                                                            
                                                            value={this.state.rfc_banco}
                                                            onChange={ this.handleInputChange}
                                                            readOnly
                                                            />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-3">
                                                    <FormGroup>
                                                        <Label>Ciuenta *</Label>
                                                            <Input
                                                            placeholder=""
                                                            type="text"
                                                            name="cuenta"
                                                            value={impuesto.cuenta}
                                                            onChange={ this.handleInputChange}
                                                            />
                                                    </FormGroup>
                                                </div>

                                            </div>
                                        </div>
                                    
                                    </div>                    
                                </Col>
                            </Row>

















                        </TabPane>
                        <TabPane tabId="2">
                            <Row>
                                <Col sm="12">
                                    <div className="row mt-4 mb-4 ">
                                        <div className="col-md-6 div_titulo mr-2">
                                            <h1><span>Tipo</span></h1>
                                                    <div className="form-group mt-4 text-left ajuste_checkbox_parametros ">                                                    
                                                        <label className="d-block ml-2">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={impuesto.factura_electronica }
                                                        onChange={this.handleInputChange}
                                                        /> &nbsp;&nbsp; Usara Facturacion Electronica
                                                        </label>
                                                         <label className="d-block ml-2">
                                                        <input type="checkbox"
                                                        name="cfd_cfdi_directo" 
                                                        checked={impuesto.cfd_cfdi_directo }
                                                        onChange={this.handleInputChange}
                                                        />&nbsp;&nbsp; Generar CFD y timbrar CFDI directo al facturar
                                                        </label>
                                                    </div>
                                        </div>
                                        <div className="col-md-3 mr-2 div_titulo">
                                                    <h1><span>Tipo de Comprobante</span></h1>
                                                        <FormGroup tag="fieldset">
                                                            <FormGroup check>
                                                                <Label check>
                                                                    <Input type="radio" value="1" name="tipo_comprobante" onChange={ this.handleInputChange} checked={parseInt(impuesto.tipo_comprobante)===1?true:false} />{' '}
                                                                    CFD
                                                                </Label>
                                                            </FormGroup>
                                                            <FormGroup check>
                                                                <Label check>
                                                                    <Input type="radio" value="2" name="tipo_comprobante" onChange={ this.handleInputChange} checked={parseInt(impuesto.tipo_comprobante)===2?true:false}/>{' '}
                                                                    CFDI
                                                                </Label>
                                                            </FormGroup>
                                                            <FormGroup check >
                                                                <Label check>
                                                                    <Input type="radio" value="3" name="tipo_comprobante"  onChange={ this.handleInputChange} checked={parseInt(impuesto.tipo_comprobante)===3?true:false}/>{' '}
                                                                    CBB
                                                                </Label>
                                                            </FormGroup>
                                                        </FormGroup>
                                                   
                                        </div> 
                                        <div className="col-md-2 div_titulo">
                                                    <h1><span>Pac</span></h1>
                                                        <FormGroup tag="fieldset">
                                                            <FormGroup check>
                                                                <Label check>
                                                                    <Input type="radio" value="1" name="pac" onChange={ this.handleInputChange} checked={parseInt(impuesto.pac)===1?true:false} />{' '}
                                                                    Ecodex
                                                                </Label>
                                                            </FormGroup>
                                                            <FormGroup check>
                                                                <Label check>
                                                                    <Input type="radio" value="2" name="pac" onChange={ this.handleInputChange} checked={parseInt(impuesto.pac)===2?true:false} />{' '}
                                                                    Virtual Pac
                                                                </Label>
                                                            </FormGroup>
                                                        </FormGroup>
                                                   
                                        </div>                                   
                                    </div> 
                                    <div className=" div_titulo pl-2">
                                        <h1><span>Parametros del Servidor de Correo Saliente</span></h1>
                                        <div className="row ">
                                            <div className="col-md-4">
                                                <FormGroup>
                                                    <Label>Servidor de Correo</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="servidor_correo"
                                                    maxLength={99}
                                                    value={impuesto.servidor_correo}
                                                    onChange={ this.handleInputChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-2">
                                                <FormGroup>
                                                    <Label>Puerto</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="puerto_servidor"
                                                    maxLength={10}
                                                    value={impuesto.puerto_servidor}
                                                    onChange={ this.handleInputChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-3 pt-2">
                                                <div className="form-group mt-4">
                                                <label >
                                                    <input type="checkbox"
                                                    name="conexion_segura" 
                                                    checked={impuesto.conexion_segura }
                                                    onChange={this.handleInputChange}
                                                    />&nbsp;&nbsp;Requiere Conexion Segura(SSL)
                                                </label>
                                                </div>
                                            </div>
                                            <div className="col-md-3 pt-2">
                                                <div className="form-group mt-4">
                                                <label >
                                                    <input type="checkbox"
                                                    name="autentificacion" 
                                                    checked={impuesto.autentificacion }
                                                    onChange={this.handleInputChange}
                                                    />&nbsp;&nbsp;Requiere Autentificacion?
                                                </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" div_titulo px-2 mt-4">
                                        <h1><span>Datos del Remitente</span></h1>
                                        <div className="row ">
                                            <div className="col-md-4">
                                                <FormGroup>
                                                    <Label>Nombre Usuario</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="usuario"
                                                    maxLength={99}
                                                    value={impuesto.usuario}
                                                    onChange={ this.handleInputChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                             
                                            <div className="col-md-4">
                                                <FormGroup>
                                                    <Label>Correo</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="correo"
                                                    maxLength={99}
                                                    value={impuesto.correo}
                                                    onChange={ this.handleInputChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-4">
                                                <FormGroup>
                                                    <Label>Contraseña</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="password"
                                                    name="contrasena"
                                                    maxLength={99}
                                                    value={impuesto.contrasena}
                                                    onChange={ this.handleInputChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-4">
                                                <FormGroup>
                                                    <Label>Titulo</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="titulo"
                                                    maxLength={99}
                                                    value={impuesto.titulo}
                                                    onChange={ this.handleInputChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-8"></div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className>Texto</label>
                                                    <Input
                                                      rows={10}                                                        
                                                      type="textarea"
                                                      name="texto"
                                                      value={impuesto.texto} 
                                                      maxLength={499}
                                                      onChange={ this.handleInputChange}
                                                      />                                                    
                                                </div>
                                            </div>

                                           
                                            
                                        </div>
                                    </div>                   
                                </Col>
                            </Row>
                        </TabPane>
                         <TabPane tabId="3">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="d-block">Archivo XML de entrada Sin Sello y Sin Frima: <b>{impuesto.xml_sin_firma_sello}</b> </label>
                                    <FileUploader extension="xml" ref="xml_sin_firma_sello"/>                          
                                </div>
                            </div>
                            <div className="col-md-6">
                                <FormGroup>
                                    <Label>Nombre del Archivo XML donde se va a guardar el CFD firmado y sellado</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cfd_sellado_firmado"
                                    maxLength={99}
                                    value={impuesto.cfd_sellado_firmado}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="d-block">Archivo que contiene el Certificado Digital(archivo.CER): <b>{impuesto.certificado_digital}</b> </label>
                                    <FileUploader extension="cer" ref="certificado_digital"/>                          
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="d-block">Archivo que contiene la llave privada(archivo.KEY): <b>{impuesto.llave_privada}</b> </label>
                                    <FileUploader extension="key" ref="llave_privada"/>                          
                                </div>
                            </div>
                            <div className="col-md-6">
                                <FormGroup>
                                    <Label>RFC del cliente CiberTec que adquirio la licencia de CiberSat</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rfc_cibertec"
                                    maxLength={13}
                                    value={impuesto.rfc_cibertec}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-6">
                                <FormGroup>
                                    <Label>Es una cadena de caracteres, la cual se genera atraves del portal CiberSat</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cibersat"
                                    maxLength={99}
                                    value={impuesto.cibersat}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>                                                  
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="4">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Serie</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="serie1"
                                    maxLength={10}
                                    value={impuesto.serie1}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Folio Inicial.</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="inicial1"
                                    value={impuesto.inicial1}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Folio Final</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="final1"
                                    value={impuesto.final1}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Folio Actual</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="actual1"
                                    value={impuesto.actual1}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div> 
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>No. Aprobacion</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="numero_aprobacion1"
                                    value={impuesto.numero_aprobacion1}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Año Aprobacion</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="ano_aprobacion1"
                                    value={impuesto.ano_aprobacion1}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                   
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="serie2"
                                    maxLength={10}
                                    value={impuesto.serie2}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                   
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="inicial2"
                                    value={impuesto.inicial2}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                   
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="final2"
                                    value={impuesto.final2}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                   
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="actual2"
                                    value={impuesto.actual2}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div> 
                            <div className="col-md-2">
                                <FormGroup>
                                   
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="numero_aprobacion2"
                                    value={impuesto.numero_aprobacion2}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                   
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="ano_aprobacion2"
                                    value={impuesto.ano_aprobacion2}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-4">
                                <FormGroup>
                                    <Label>Timbres Disponibles</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="timbres"
                                    value={impuesto.timbres}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Version</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="version"
                                    value={impuesto.version}
                                    onChange={ this.handleInputChange}
                                    />
                                </FormGroup>
                            </div>                                                 
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>                                                       
                    </TabContent>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.datosfacturacion.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
                <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                />
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        datosfacturacion : state.datosfacturacion,
    }
};

export default connect(mapStateToProps, actions)(ParamtrosModal)


// WEBPACK FOOTER //
// ./src/components/datosfactura/modal.js